module.exports = __webpack_public_path__ + "static/TakkScroll1-1467682032535f14feb5cbb2cab345bc.png";